import { useEffect, useState } from "react";
import Footer from "../Footer";
import Header from "../Header";
import { ManageWebsiteModal } from "../ManageWebsiteModal/ManageWebsiteModal";
import "./DomainPurchaseSuccess.scss";
import { useDispatch, useSelector } from "react-redux";
import { clevertapEventPush, getEventPlatform, redirectToDashy } from "../../../../Utils/common";
import { getDomainCart, handleRequestToCallback } from "../../utils/common";
import { DOMAIN_HISTORY } from "../../../../Constants/routesConstant";
import { sendGAEvent } from "../../../../Utils/GAEvents";
import { TRACKING_EVENTS } from "../../../../Utils/GAEvents/gaEventsConstants";
import { authenticateUser, getLatestDomainPurchaseDetails } from "../../../../Redux/Actions";
import CenteredLoader from "../../../../Components/CenteredLoader";
import AchievementSection from "../Achievements";
import DashboardRedirectBanner from "./components/DashboardRedirectBanner";
import PurchaseSuccessCTA from "./components/PurchaseSuccessCTA";
import ExploreThemeWithOffer from "./components/ExploreThemeWithOffer";
import ConnectWithDeveloper from "./components/ConnectWithDeveloper";
import BusinessTools from "./components/BusinessTools";
import AppDownloadSection from "./components/AppDownloadSection";
import ExpertSupport from "./components/ExpertSupport";
import WhyChooseOurWebsite from "./components/WhyChooseOurWebsite";
import DLPPostPurchaseHeroSection from "./components/DLPPostPurchaseHeroSection";
import { getAuthToken } from "../../../../Utils/authToken";
import { THEME_UPSELL_POPUP_DISPLAYED_TEXT } from "../../utils/constant";

const DomainPurchaseSuccess = () => {
  const dispatch = useDispatch();
  const [showWebsitePopUp, setShowWebsitePopUp] = useState(false);
  const { subscriptionData, storeData } = useSelector((state) => ({
    subscriptionData: state.themeReducer.subscriptionDetails,
    storeData: state.storeReducer.store,
  }));
  const [loader, setLoader] = useState(true);
  const handleCloseManageDomain = () => setShowWebsitePopUp(false);
  const handleOpenVerifyModalFromHeader = () => {
    window.location.href = process.env.REACT_APP_DIGITALSHOWROOM_URL;
  };

  const domainCart = getDomainCart();

  useEffect(() => {
    const authToken = getAuthToken();
    if (authToken) {
      dispatch(authenticateUser(authToken));
    }
    dispatch(
      getLatestDomainPurchaseDetails(null, (status) => {
        if (status) {
          setLoader(false);
        }
      }),
    );
    clevertapEventPush("DLP_Purchased", {
      domain: domainCart?.items[0]?.data?.domain,
      number: storeData?.phone,
      price: domainCart?.amount,
    });
    sendPostPurchaseDataToGAEvent(TRACKING_EVENTS.domainPurchased);
  }, []);

  const sendPostPurchaseDataToGAEvent = (event, args = {}) => {
    const { device } = getEventPlatform();
    sendGAEvent(event, {
      dimension1: subscriptionData?.domain?.domain_name || "",
      dimension2: device,
      dimension4: domainCart?.amount, // amount
      dimension5: storeData?.phone, // number
      ...args,
    });
  };

  const handleManageDNS = () => {
    sendPostPurchaseDataToGAEvent(TRACKING_EVENTS.postPurchaseManageDomainClicked);
    redirectToDashy(`${DOMAIN_HISTORY}`);
  };

  return (
    <div className="dlp__postpurchase__wrapper">
      <CenteredLoader show={loader} />
      <Header
        hideCart={true}
        postPurchase={true}
        openCallBackModal={handleRequestToCallback}
        handleOpenVerifyModalFromHeader={handleOpenVerifyModalFromHeader}
      />
      <DashboardRedirectBanner sendPostPurchaseDataToGAEvent={sendPostPurchaseDataToGAEvent} />
      <section className="tw-mt-8 tw-flex tw-justify-center">
        <PurchaseSuccessCTA handleManageDNS={handleManageDNS} />
      </section>
      <section className="desktop:tw-max-w-[1280px] tw-mx-auto tw-my-0 tw-mt-[52px] tw-max-w-[90%] tw-px-6">
        <DLPPostPurchaseHeroSection />
      </section>
      <WhyChooseOurWebsite />
      <BusinessTools sendPostPurchaseDataToGAEvent={sendPostPurchaseDataToGAEvent} />
      <AppDownloadSection />
      <ExpertSupport />
      <div className="tw-py-[43px]">
        <AchievementSection />
      </div>
      <Footer openCallBackModal={handleRequestToCallback} />
      {showWebsitePopUp && (
        <ManageWebsiteModal
          handleCloseManageDomain={handleCloseManageDomain}
          sendPostPurchaseDataToGAEvent={sendPostPurchaseDataToGAEvent}
        />
      )}
    </div>
  );
};

export default DomainPurchaseSuccess;
